import styled, { css } from 'styled-components';
import { Alert as rbAlert } from 'react-bootstrap';

const Alert = styled(rbAlert)`
  border-radius: 0;

  ${(props) => props?.variant === 'warning' && warning}

  ${(props) => props?.variant === 'danger' && danger}
`;

const warning = css`
  background-color: ${({theme}) => theme.palette.alert[5]};
  border: 1px solid${({theme}) => theme.palette.alert[2]};
  color: ${({theme}) => theme.palette.grayscale[1]};
`;

const danger = css`
  background-color: ${({theme}) => theme.palette.danger[5]};
  border: 1px solid ${({theme}) => theme.palette.danger[3]};
  color: ${({theme}) => theme.palette.grayscale[1]};
`;

export default Alert;
